import * as React from 'react';

export const BOOKMARK_ICON = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M18.5 22.5L12 16 5.5 22.5 5.5 0.5 18.5 0.5z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export const ADDRESS_BOOK = (
  <svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5,0.5 L18.5,0.5 L18.5,23.5 L1.5,23.5 L1.5,0.5 Z M18.5,15.5 L20.5,15.5 C21.1,15.5 21.5,15.9 21.5,16.5 L21.5,22.5 C21.5,23.1 21.1,23.5 20.5,23.5 L18.5,23.5 M18,7.5 L20.5,7.5 C21.1,7.5 21.5,7.9 21.5,8.5 L21.5,14.5 C21.5,15.1 21.1,15.5 20.5,15.5 L18,15.5 M18.5,0.5 L20.5,0.5 C21.1,0.5 21.5,0.9 21.5,1.5 L21.5,6.5 C21.5,7.1 21.1,7.5 20.5,7.5 L18.5,7.5 M13.5,12.5 C14,12.5 14.5,12.9 14.5,13.5 L14.5,17.5 L5.5,17.5 L5.5,17.5 L5.5,13.5 C5.5,13 6,12.5 6.5,12.5 L13.5,12.5 Z M10.5,5.5 C11.6,5.5 12.5,6.4 12.5,7.5 L12.5,8.5 C12.5,9.6 11.6,10.5 10.5,10.5 L9.5,10.5 C8.4,10.5 7.5,9.6 7.5,8.5 L7.5,7.5 C7.5,6.4 8.4,5.5 9.5,5.5 L10.5,5.5 Z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export const VOICE_CALL = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="👤Icons/Content/voice-call-1-small/black"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="voice-call-1-small" transform="translate(1.000000, 2.000000)" stroke="#000000">
        <path d="M17.5,20.3 L21.5,16.5 C21.7,16.3 21.7,15.7 21.5,15.5 L18.5,12.5 C18.3,12.3 17.7,12.3 17.5,12.5 L16,13.8 C16,13.8 15.3,14.9 11.1,10.7 L10.6,10.2 C6.3,5.9 7.5,5.5 7.5,5.5 L8.5,4.5 C8.7,4.3 8.7,3.7 8.5,3.5 L5.5,0.5 C5.3,0.3 4.7,0.3 4.5,0.5 L0.7,4.5 C0.7,4.5 6.5,14.1 17.5,20.3 Z"></path>
      </g>
    </g>
  </svg>
);

export const SAVE_AS = (
  <svg
    width="24px"
    height="25px"
    viewBox="0 0 24 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="👤Icons/System/system-save-as-small/black"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="system-save-as-small" transform="translate(1.000000, 2.000000)" stroke="#000000">
        <path d="M5.5,9 L5.5,15.5 L17.5,15.5 L17.5,9 M11.5,7 L11.5,13.4"></path>
        <polyline points="8.262 10.154 11.51 13.4 14.739 10.171"></polyline>
        <circle id="Oval" cx="11.5" cy="11.5" r="11"></circle>
      </g>
    </g>
  </svg>
);
export const DIRECT_MAIL = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="👤Icons/Content/direct-mail-small/black"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="direct-mail-small" transform="translate(1.000000, 4.000000)" stroke="#000000">
        <path d="M21.5,15.5 L2.5,15.5 C1.3954305,15.5 0.5,14.6045695 0.5,13.5 L0.5,0.5 L19.5,0.5 C20.6045695,0.5 21.5,1.3954305 21.5,2.5 L21.5,15.5 Z"></path>
        <polyline points="4 5.5 11 11 18 5.5"></polyline>
      </g>
    </g>
  </svg>
);

export const GEO_FENCE = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="👤Icons/Content/geofence-small/black"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="geofence-small" transform="translate(2.000000, 1.000000)" stroke="#000000">
        <path d="M14.43,16.5 C17.88,16.92 20.43,18.04 20.43,19.03 C20.43,20.39 15.86,21.5 10.31,21.5 C4.76,21.5 0.31,20.39 0.31,19.03 C0.31,18.03 2.84,16.88 6.46,16.5"></path>
        <path d="M10.5,18 C10.5,18 4.68,9.73 4.68,6.47 C4.546,3.209 7.239,0.384 10.5,0.25 C13.761,0.384 16.454,3.209 16.32,6.47 C16.32,9.73 10.5,18 10.5,18 Z"></path>
        <path d="M10.5,4 C11.897,4 13,5.103 13,6.5 C13,7.897 11.897,9 10.5,9 C9.103,9 8,7.897 8,6.5 C8,5.103 9.103,4 10.5,4 Z"></path>
      </g>
    </g>
  </svg>
);

export const WWW_LINK = (
  <svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M19.8,20.5 L16.7,12.8 M14.9,17.2 L16.7,12.8 L21.1,14.6" stroke="currentColor" />
      <path
        d="M16.1,7 L17.3,7 L18.4,9.7 L19.4,7 L20.7,7 L21.7,9.7 L22.8,7 L24,7 L22.3,10.8 L21,10.8 L20,8.2 L19,10.8 L17.7,10.8 L16.1,7 Z M8,7 L9.2,7 L10.3,9.7 L11.3,7 L12.6,7 L13.6,9.7 L14.8,7 L16,7 L14.3,10.8 L13,10.8 L12,8.2 L11,10.8 L9.7,10.8 L8,7 Z M0,7 L1.2,7 L2.3,9.7 L3.3,7 L4.6,7 L5.6,9.7 L6.7,7 L7.9,7 L6.2,10.8 L5,10.8 L4,8.2 L3,10.8 L1.7,10.8 L0,7 Z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
export const FACEBOOK_ICON = (
  <>
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>facebook-icon</title>
      <path
        d="M20.1,20.4 L15.1,20.4 L15.1,24.8 L20.1,24.8 L20.1,38 L26,38 L26,24.8 L31.9,24.8 L31.9,20.4 L26,20.4 L26,18.6 C26,17.3 27.4,14.5 29.4,14.5 L31.8,14.5 L31.8,10.1 L26.7,10.1 C19.5,11.2 20.1,20.4 20.1,20.4 L20.1,20.4 Z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
      />
    </svg>
  </>
);

export const TWITTER_ICON = (
  <>
    <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>x-icon</title>
      <path
        fill="currentColor"
        d="M27.18 21.89 37.29 10h-4.66l-7.64 8.94L18.43 10H9l11.21 15.29L9.51 38h4.6l8.32-9.78L29.67 38H39L27.18 21.89ZM14.34 12.7h2.74L33.6 35.2h-2.55L14.34 12.7Z"
      />
    </svg>
  </>
);

export const INSTAGRAM_ICON = (
  <>
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>instagram-icon</title>
      <path
        d="M25.1604201,12.0008097 C27.3834677,12.0044763 27.8383141,12.0216005 28.9475847,12.0722133 C30.2248447,12.1304697 31.0971676,12.3333433 31.860456,12.6300083 C32.6495621,12.9366288 33.3187732,13.3469487 33.985936,14.014064 C34.6530513,14.6812268 35.0633712,15.3504379 35.3700394,16.139544 C35.6666567,16.9028324 35.8695303,17.7751553 35.9277867,19.0524153 C35.9861861,20.3323429 36,20.7409957 36,24.0000238 C36,27.2590043 35.9861861,27.6676571 35.9277867,28.9475847 C35.8695303,30.2248447 35.6666567,31.0971676 35.3700394,31.860456 C35.0633712,32.6495621 34.6530513,33.3187732 33.985936,33.985936 C33.3187732,34.6530513 32.6495621,35.0633712 31.860456,35.3700394 C31.0971676,35.6666567 30.2248447,35.8695303 28.9475847,35.9277867 C27.6676571,35.9861861 27.2590043,36 24.0000238,36 C20.7409957,36 20.3323429,35.9861861 19.0524153,35.9277867 C17.7751553,35.8695303 16.9028324,35.6666567 16.139544,35.3700394 C15.3504379,35.0633712 14.6812268,34.6530513 14.014064,33.985936 C13.3469487,33.3187732 12.9366288,32.6495621 12.6300083,31.860456 C12.3333433,31.0971676 12.1304697,30.2248447 12.0722133,28.9475847 C12.0216005,27.8383141 12.0044763,27.3834677 12.0008097,25.1604201 L12.0008097,22.8396109 C12.0044763,20.6165323 12.0216005,20.1616859 12.0722133,19.0524153 C12.1304697,17.7751553 12.3333433,16.9028324 12.6300083,16.139544 C12.9366288,15.3504379 13.3469487,14.6812268 14.014064,14.014064 C14.6812268,13.3469487 15.3504379,12.9366288 16.139544,12.6300083 C16.9028324,12.3333433 17.7751553,12.1304697 19.0524153,12.0722133 C20.1616859,12.0216005 20.6165323,12.0044763 22.8396109,12.0008097 Z M25.1398181,14.16289 L22.8602129,14.16289 C20.6789096,14.1662315 20.2476083,14.1820979 19.1509702,14.2321328 C17.9809821,14.2854829 17.3455912,14.4809732 16.9227435,14.6453107 C16.3626144,14.8629984 15.9628692,15.1230329 15.5429749,15.5429749 C15.1230329,15.9628692 14.8629984,16.3626144 14.6453107,16.9227435 C14.4809732,17.3455912 14.2854829,17.9809821 14.2321328,19.1509702 C14.1820979,20.2476083 14.1662315,20.6789096 14.16289,22.8602129 L14.16289,25.1398181 C14.1662315,27.3210904 14.1820979,27.7523917 14.2321328,28.8490298 C14.2854829,30.0190179 14.4809732,30.6544088 14.6453107,31.0772565 C14.8629984,31.6373856 15.1230805,32.0371308 15.5429749,32.4570251 C15.9628692,32.8769671 16.3626144,33.1370016 16.9227435,33.3546893 C17.3455912,33.5190268 17.9809821,33.7145171 19.1509702,33.7678672 C20.2474844,33.8179021 20.6786977,33.8337685 22.8601348,33.83711 L25.1398985,33.83711 C27.3213133,33.8337685 27.7525569,33.8179021 28.8490298,33.7678672 C30.0190179,33.7145171 30.6544088,33.5190268 31.0772565,33.3546893 C31.6373856,33.1370016 32.0371308,32.8769671 32.4570251,32.4570251 C32.8769671,32.0371308 33.1370016,31.6373856 33.3546893,31.0772565 C33.5190268,30.6544088 33.7145171,30.0190179 33.7678672,28.8490298 C33.8179021,27.7523917 33.8337685,27.3210904 33.83711,25.1398181 L33.83711,22.8602129 C33.8337685,20.6789096 33.8179021,20.2476083 33.7678672,19.1509702 C33.7145171,17.9809821 33.5190268,17.3455912 33.3546893,16.9227435 C33.1370016,16.3626144 32.8769671,15.9628692 32.4570251,15.5429749 C32.0371308,15.1230329 31.6373856,14.8629984 31.0772565,14.6453107 C30.6544088,14.4809732 30.0190179,14.2854829 28.8490298,14.2321328 C27.7523917,14.1820979 27.3210904,14.1662315 25.1398181,14.16289 Z M24.0000238,17.8378417 C27.4032879,17.8378417 30.1621583,20.5967121 30.1621583,24.0000238 C30.1621583,27.4032879 27.4032879,30.1621583 24.0000238,30.1621583 C20.5967121,30.1621583 17.8378417,27.4032879 17.8378417,24.0000238 C17.8378417,20.5967121 20.5967121,17.8378417 24.0000238,17.8378417 Z M24.0000238,20 C21.7908507,20 20,21.7908507 20,24.0000238 C20,26.2091493 21.7908507,28 24.0000238,28 C26.2091493,28 28,26.2091493 28,24.0000238 C28,21.7908507 26.2091493,20 24.0000238,20 Z M30.4056161,16.1543582 C31.2009146,16.1543582 31.8456418,16.7990854 31.8456418,17.5943839 C31.8456418,18.3896825 31.2009146,19.034362 30.4056161,19.034362 C29.6103652,19.034362 28.965638,18.3896825 28.965638,17.5943839 C28.965638,16.7990854 29.6103652,16.1543582 30.4056161,16.1543582 Z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
      />
    </svg>
  </>
);

export const LINKENDIN_ICON = (
  <>
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>linkedin-icon</title>
      <path
        d="M34.2,12 L13.8,12 C12.8,12 12,12.8 12,13.7 L12,34.2 C12,35.2 12.8,35.9 13.8,35.9 L34.3,35.9 C35.3,35.9 36.1,35.1 36.1,34.2 L36.1,13.7 C36,12.8 35.2,12 34.2,12 L34.2,12 Z M19.1,32.5 L15.5,32.5 L15.5,21 L19.1,21 L19.1,32.5 L19.1,32.5 Z M17.3,19.4 C16.2,19.4 15.2,18.5 15.2,17.3 C15.2,16.2 16.1,15.2 17.3,15.2 C18.5,15.2 19.4,16.1 19.4,17.3 C19.4,18.5 18.5,19.4 17.3,19.4 Z M32.5,32.5 L28.9,32.5 L28.9,26.9 C28.9,25.6 28.9,23.9 27,23.9 C25.1,23.9 24.9,25.3 24.9,26.8 L24.9,32.5 L21.3,32.5 L21.3,21 L24.7,21 L24.7,22.6 L24.7,22.6 C25.2,21.7 26.3,20.7 28.1,20.7 C31.7,20.7 32.4,23.1 32.4,26.2 L32.5,32.5 L32.5,32.5 Z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
      />
    </svg>
  </>
);
export const YOUTUBE_ICON = (
  <>
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>youtube-icon</title>
      <path
        d="M38.7,18 C38.7,18 38.4,15.9 37.5,15 C36.4,13.8 35.1,13.8 34.5,13.7 C30.3,13.5 24,13.5 24,13.5 L24,13.5 C24,13.5 17.7,13.5 13.5,13.8 C12.9,13.9 11.6,13.9 10.5,15.1 C9.6,16 9.3,18.1 9.3,18.1 C9.3,18.1 9,20.4 9,22.9 L9,25.2 C9,27.6 9.3,30 9.3,30 C9.3,30 9.6,32.1 10.5,33 C11.6,34.2 13.1,34.2 13.8,34.3 C16.2,34.5 24,34.6 24,34.6 C24,34.6 30.3,34.6 34.5,34.3 C35.1,34.2 36.4,34.2 37.5,33 C38.4,32.1 38.7,30 38.7,30 C38.7,30 39,27.6 39,25.1 L39,22.8 C39,20.4 38.7,18 38.7,18 Z M20.9,27.9 L20.9,19.5 L29,23.7 L20.9,27.9 Z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
      />
    </svg>
  </>
);
export const VIMEO_ICON = (
  <>
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>vimeo-icon</title>
      <path
        d="M36.6,17.3130517 C36.5,19.9130517 34.7,23.4130517 31.2,27.9130517 C27.6,32.6130517 24.5,34.9130517 22,34.9130517 C20.4,34.9130517 19.1,33.5130517 18.1,30.6130517 L16,22.7130517 C15.2,19.8130517 14.4,18.4130517 13.4,18.4130517 C12.6,18.7130517 11.9,19.1130517 11.3,19.7130517 L10,18.2130517 C11.3,17.0130517 12.6,15.9130517 13.9,14.7130517 C15.6,13.2130517 17,12.4130517 17.8,12.3130517 C19.9,12.1130517 21.1,13.5130517 21.6,16.5130517 C22.1,19.8130517 22.5,21.8130517 22.7,22.6130517 C23.3,25.3130517 24,26.7130517 24.7,26.7130517 C25.3,26.7130517 26.1,25.8130517 27.2,24.1130517 C28.1,22.9130517 28.7,21.5130517 29,20.1130517 C29.2,18.6130517 28.6,17.8130517 27.2,17.8130517 C26.5,17.8130517 25.9,18.0130517 25.2,18.2130517 C26.5,13.9130517 29,11.8130517 32.7,12.0130517 C35.4,12.1130517 36.7,13.9130517 36.6,17.3130517 L36.6,17.3130517 Z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
      />
    </svg>
  </>
);
